/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import Page from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'

class ItemsBascket extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      details: [],
      lengthdetails: 0,
      printInfo: [],
      aggregation: {}
    }
  }

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    const {deliveryPackId} = this.props.match.params
    sessionStorage.setItem('params', `deliveryPackId=${deliveryPackId}`)
    this.setState({
      loading: true
    })

    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DETAIL
        }?export=false&pageSize=10&pageNumber=1&deliveryPackId=${deliveryPackId}`,
        {}
      )
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          this.setState({
            details: response.data.object.result,
            lengthdetails: response.data.object.countAll,
            aggregation: response.data.object.aggregation
          })
          // alert(JSON.stringify(response.data))
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  onResultFetched(data) {
    this.setState({
      details: data
    })
  }

  changeDropDown(data) {
    this.setState({
      details: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DETAIL
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['discountAmountValue'] =
              excelReport[i]['discountAmount'] + excelReport[i]['extraDiscountAmount']
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DETAIL
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            printInfo: response.data.object.result
          })
        } else {
          this.setState({
            printInfo: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let urlParams = sessionStorage.getItem('params')
    let pageNumber = sessionStorage.getItem('pageNumber')

    let excelColumns = [
      {title: 'کد محصول', value: 'productCode'},
      {title: 'نام محصول', value: 'productName'},
      {title: 'نام تامین کننده', value: 'providerName'},
      {title: 'تعداد', value: 'quantity'},
      {title: 'واحد شمارش', value: 'productUnitTitle'},
      {title: 'قیمت واحد', value: 'unitPrice'},
      {title: 'قیمت کل', value: 'totalAmount'},
      {title: 'تخفیف', value: 'discountAmount'},
      {title: 'قابل پرداخت', value: 'payableAmount'}
    ]
    let {invoiceNum, invoiceId, buyerName} = this.props.match.params
    let printCol = [
      'ردیف',
      'کد محصول',
      'بارکد محصول',
      'نام محصول',
      'تامین کننده',
      'تعداد',
      'واحد',
      'قیمت واحد',
      'قیمت کل',
      'تخفیف سایت',
      'تخفیف تامین کننده',
      'قابل پرداخت'
    ]
    let reporterName = cookie.load('name')

    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'گزارش جزییات پارت تحویل ' + buyerName + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'articleId'}
                field={'articleId'}
                title={'کد محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productCode'}
                field={'productCode'}
                title={'بارکد محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productName'}
                field={'productName'}
                title={'نام محصول'}
                width="300px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                width="300px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'quantity'}
                field={'quantity'}
                title={'تعداد'}
                width="50px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productUnitTitle'}
                field={'productUnitTitle'}
                title={'واحد'}
                width="50px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'unitPrice'}
                field={'unitPrice'}
                title={'قیمت واحد'}
                width="120px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'totalAmount'}
                field={'totalAmount'}
                title={'قیمت کل'}
                width="120px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'websiteDiscountAmount'}
                field={'websiteDiscountAmount'}
                title={'تخفیف سایت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'providerDiscountAmount'}
                field={'providerDiscountAmount'}
                title={'تخفیف تامین کننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'payableAmount'}
                title={'قابل پرداخت'}
                width="120px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header={'جزییات پارت تحویل شناسه فاکتور ' + invoiceNum}
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={12}
              rightColSpan={6}
              centerColSpan={1}
              leftColSpan={5}
              centerSection={''}
              rightSection={' نام خریدار : ' + buyerName + ' به شماره فاکتور ' + invoiceId}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((detail, index) => (
                <tr key={index}>
                  <td>{(pageNumber - 1) * 10 + index + 1}</td>
                  <td>{detail.articleId}</td>
                  <td>{detail.productCode}</td>
                  <td>{detail.productName}</td>
                  <td>{detail.providerName}</td>
                  <td>{detail.quantity}</td>
                  <td>{detail.productUnitTitle}</td>
                  <td className="priceCell">{accounting.formatMoney(detail.unitPrice, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(detail.totalAmount, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(Number(detail.websiteDiscountAmount), '', ',')}</td>
                  <td className="priceCell">
                    {accounting.formatMoney(Number(detail.providerDiscountAmount), '', ',')}
                  </td>
                  <td className="priceCell">{accounting.formatMoney(detail.payableAmount, '', ',')}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={5}>مجموع</td>
                <td>{this.state.aggregation.quantity}</td>
                <td />
                <td className="priceCell">{accounting.formatMoney(this.state.aggregation.unitPrice, '', ',')}</td>
                <td className="priceCell">{accounting.formatMoney(this.state.aggregation.totalAmount, '', ',')}</td>
                <td className="priceCell">
                  {accounting.formatMoney(this.state.aggregation.websiteDiscountAmount, '', ',')}
                </td>
                <td className="priceCell">
                  {accounting.formatMoney(this.state.aggregation.providerDiscountAmount, '', ',')}
                </td>
                <td className="priceCell">{accounting.formatMoney(this.state.aggregation.payableAmount, '', ',')}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>پارت تحویل</li>
            <li>جزییات پارت تحویل</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl=""
                  showRow={false}
                  printLink=""
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DETAIL + '?export=true'}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DETAIL}
                  excelColumns={excelColumns}
                  titleAdd=""
                />

                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="detailsInfoTable">
              <ul>
                <li>شناسه فاکتور : {invoiceNum}</li>
                <li>شماره فاکتور : {invoiceId}</li>
                <li>نام خریدار : {buyerName}</li>
              </ul>
            </div>

            <table className="baseTable">
              <tbody>
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>کد محصول</td>
                  <td>بارکد محصول</td>
                  <td>نام محصول</td>
                  <td>نام تامین کننده</td>
                  <td>تعداد</td>
                  <td>واحد شمارش</td>
                  <td className="priceCell">قیمت واحد</td>
                  <td className="priceCell">قیمت کل</td>
                  <td className="priceCell">تخفیف سایت</td>
                  <td className="priceCell">تخفیف تامین کننده</td>
                  <td className="priceCell">قابل پرداخت</td>
                </tr>
                {this.state.details.map((detail, index) => (
                  <tr key={index}>
                    <td>{(pageNumber - 1) * 10 + index + 1}</td>
                    <td>{detail.articleId}</td>
                    <td>{detail.productCode}</td>
                    <td>
                      <a target="_blank" href={productShop({articleId: detail.articleId})}>
                        {detail.productName}
                      </a>
                    </td>
                    <td>{detail.providerName}</td>
                    <td>{detail.quantity}</td>
                    <td>{detail.productUnitTitle}</td>
                    <td className="priceCell">{accounting.formatMoney(detail.unitPrice, '', ',')}</td>
                    <td className="priceCell">{accounting.formatMoney(detail.totalAmount, '', ',')}</td>
                    <td className="priceCell">
                      {accounting.formatMoney(Number(detail.websiteDiscountAmount), '', ',')}
                    </td>
                    <td className="priceCell">
                      {accounting.formatMoney(Number(detail.providerDiscountAmount), '', ',')}
                    </td>
                    <td className="priceCell">{accounting.formatMoney(detail.payableAmount, '', ',')}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={5}>مجموع</td>
                  <td>{this.state.aggregation.quantity}</td>
                  <td />
                  <td className="priceCell">{accounting.formatMoney(this.state.aggregation.unitPrice, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(this.state.aggregation.totalAmount, '', ',')}</td>
                  <td className="priceCell">
                    {accounting.formatMoney(this.state.aggregation.websiteDiscountAmount, '', ',')}
                  </td>
                  <td className="priceCell">
                    {accounting.formatMoney(this.state.aggregation.providerDiscountAmount, '', ',')}
                  </td>
                  <td className="priceCell">{accounting.formatMoney(this.state.aggregation.payableAmount, '', ',')}</td>
                </tr>
              </tbody>
            </table>
            <div className="paginationWrapp">
              <Page
                defaultCurrent={1}
                total={this.state.lengthdetails}
                onResultFetched={this.onResultFetched.bind(this)}
                url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DETAIL}
                urlParams={urlParams}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ItemsBascket
